<template>
  <div class="preview" :class="{'preview-side': side}" v-if="show">
    <div class="product-image" v-html="currentImage"></div>
    <div class="product-info">{{product.type}}</div>
  </div>
</template>

<script>
import Client from "@/models/HttpClient.js";
import Svg from "@/models/Svg.js";
export default {
  data() {
    return {
      side: false,
      show: false,
      currentImage: null,
      loadedProducts: [],
      product: null,
      client: new Client(this.$session.get("jwt"))
    };
  },
  methods: {
    async showProduct(product) {
      if (this.product != null) {
        if (product.id === this.product.id) {
          return;
        }
      }
      this.product = product;
      this.side = product.is_flipped;
      const alreadyLoaded = this.loadedProducts.find(e => {
        return e.position == product.position && e.order_id == product.order_id;
      });

      if (alreadyLoaded) {
        this.currentImage = alreadyLoaded.image;
        this.show = true;
      } else {
        const productImage = await this.client.instance.get(
          `/products/${product.id}/image`
        );
        const imageData = Svg.fix(productImage.data);
        this.currentImage = imageData;
        this.show = true;
        this.loadedProducts.push({
          position: product.position,
          order_id: product.order_id,
          image: imageData
        });
      }
    },

    hideProduct() {
      this.currentImage = null;
      this.show = false;
    }
  }
};
</script>

<style scoped>
.preview {
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.877),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  z-index: 100;
  height: 230px;
  background: white;
}
.preview-side {
  width: 200px;
  transform: translate(100%) rotate(90deg);
  transform-origin: left top;
}
.product-info {
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
}
</style>